// export default SideBarMain;
import "./index.scss";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../authProvider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { getSidebarEntries } from "../../../constants";
import rolesPermissions from "../../../config/rolesPermissions";
import LogoCoImg from "../../../assets/logo.png";

const SideBarMain = () => {
  const location = useLocation();
  const { currentUser } = useAuth();

  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth);
  const [activeSubmenu, setActiveSubmenu] = useState(null);

  const SidebarEntries = getSidebarEntries();
  const navigate = useNavigate();

  useEffect(() => {
    if (document.body.classList.contains("toggle-sidebar")) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  }, [currentUser]);

  const toggleSubmenu = (index) => {
    setActiveSubmenu(activeSubmenu === index ? null : index);
  };

  useLayoutEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isSubmenuActive = (subItems) => {
    return subItems.some((subItem) => location.pathname.includes(subItem.link));
  };
  const { handelLogout } = useAuth();
  const handleLogoutClick = async () => {
    await handelLogout(); // logout via le context
    navigate("/login"); // rediriger après logout
  };

  const userPermissions = rolesPermissions[currentUser?.role]?.canView || [];

  return (
    <>
      <div className="my-4 ms-4 d-flex align-items-center justify-content-start">
        <img src={LogoCoImg} className="logoco" alt="photo de profil" />
      </div>

      <div className="navbar-content">
        <div className="card border-0 mx-3 mt-3">
          <div className="card-body border-0">
            <ul className="sidebar-nav" id="sidebar-nav">
              {SidebarEntries &&
                SidebarEntries.length > 0 &&
                SidebarEntries.map(
                  (item, index) =>
                    userPermissions.includes(item.text) && (
                      <li
                        className="nav-item mb-2"
                        key={index}
                        onClick={() => item?.subItems && toggleSubmenu(index)}>
                        <NavLink
                          to={item?.link}
                          className={`nav-link collapsed ${
                            (item?.link === "/devis" &&
                              location?.pathname === "/") ||
                            location?.pathname?.includes(item?.link)
                              ? "nav-link-active"
                              : "text-black"
                          }`}
                          activeclassname="nav-link">
                          <div
                            id="icon"
                            className={`${
                              location?.pathname?.includes(item?.link)
                                ? "text-white"
                                : "text-black"
                            } linkIcon`}
                            dangerouslySetInnerHTML={{
                              __html: item?.icon,
                            }}></div>
                          {open && (
                            <span className="sidebar_navlink ps-2">
                              {item?.text}
                            </span>
                          )}
                          {item?.subItems && (
                            <FontAwesomeIcon
                              icon={
                                activeSubmenu === index
                                  ? faChevronUp
                                  : faChevronDown
                              }
                              className="submenu-toggle-icon"
                            />
                          )}
                        </NavLink>

                        {item?.subItems && (
                          <ul
                            className={`submenu ${
                              activeSubmenu === index ||
                              isSubmenuActive(item?.subItems)
                                ? "submenu-open"
                                : "submenu-closed"
                            }`}>
                            {item.subItems.map((subItem, subIndex) => (
                              <li key={subIndex} className="nav-item">
                                <NavLink
                                  to={subItem.link}
                                  className={`nav-link ${
                                    location?.pathname?.includes(subItem?.link)
                                      ? "nav-link-active"
                                      : ""
                                  }`}>
                                  <span>{subItem.text}</span>
                                </NavLink>
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    )
                )}
            </ul>
          </div>
        </div>

        {/* Add Logout Button with text at the bottom of the sidebar */}
        <div className="sidebar-footer d-flex flex-column align-items-center gap-3">
          <div className="d-flex flex-column align-items-center text-center">
            <h6 className="mb-1">
              {" "}
              Entreprise:
              {" " + currentUser?.company
                ? currentUser?.company
                : " Company name"}
            </h6>
            <p className="mb-0">
              {currentUser?.email || "Email not available"}
            </p>
          </div>

          <button
            onClick={handleLogoutClick}
            className="btn d-flex align-items-center w-100 justify-content-center">
            <svg
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M13.3549 5.03662H9.78842C6.85529 5.03662 5.01624 7.11318 5.01624 10.053V17.9834C5.01624 20.9232 6.8467 22.9998 9.78842 22.9998H18.2053C21.148 22.9998 22.9785 20.9232 22.9785 17.9834V14.1413"
                stroke="#636C77"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.8134 12.7936L17.9416 5.66532C18.8297 4.77823 20.2691 4.77823 21.1571 5.66532L22.318 6.82617C23.206 7.71422 23.206 9.15456 22.318 10.0417L15.1554 17.2042C14.7672 17.5924 14.2406 17.8109 13.6912 17.8109H10.118L10.2077 14.2053C10.2211 13.6749 10.4376 13.1694 10.8134 12.7936Z"
                stroke="#636C77"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M16.8584 6.7666L21.2137 11.1219"
                stroke="#636C77"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <rect
                x="0.5"
                y="0.5"
                width="27"
                height="27"
                rx="7.5"
                fill="white"
              />
              <rect
                x="0.5"
                y="0.5"
                width="27"
                height="27"
                rx="7.5"
                stroke="#E4E6E9"
              />
              <path
                d="M10.2703 13.9078H20M10.2703 13.9078L14.1945 17.8156M10.2703 13.9078L14.1945 10M8 18V10.2162"
                stroke="#3cbbbc"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className="p-3">Déconnexion</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default SideBarMain;
